import { useMutation } from '@apollo/client'
import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Box from '../Global/Box'
import ContentHeader from '../Layout/ContentHeader'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import ReorderItems from './ReorderItems'
import { useLoading } from '../../LoadingOverlay/LoadingOverlayContext'
import { All_ROLE_PERMISSIONS } from '../../graphql/Catalog/Roles/roleModules'
import { All_USER_PERMISSIONS } from '../../graphql/Catalog/Modules/modules'
import { UPDATE_ORDER_PERMISSIONS } from '../../graphql/OrderPermissions/orderPermissions'

const OrderPermissions = () => {
  const { type: typePermiss, id: _id } = useParams()
  const { showLoading, hideLoading } = useLoading()

  //STATES
  const [backPage, setBackPage] = useState('/')
  const [role, setRole] = useState(null)
  const [modules, setModules] = useState([])

  //MUATIONS
  const [rolePermissions] = useMutation(All_ROLE_PERMISSIONS)
  const [userPermissions] = useMutation(All_USER_PERMISSIONS)
  const [updateOrderPermissions] = useMutation(UPDATE_ORDER_PERMISSIONS)

  const trasformData = async (permissions) => {
    const newArray = []
    let newOrder = 1

    for await (const permission of permissions) {
      let foundPerm = newArray.find(
        (item) => item.id_module === permission.id_module
      )

      if (foundPerm) {
        if (permission.submodule_info) {
          foundPerm.submodules.push({
            id_submodule: permission.id_submodule,
            submodule_info: permission.submodule_info,
          })
        }
      } else {
        const submodules = []
        if (permission.submodule_info) {
          submodules.push({
            id_submodule: permission.id_submodule,
            submodule_info: permission.submodule_info,
          })
        }

        newArray.push({
          order: newOrder,
          id_module: permission.id_module,
          module_info: permission.module_info,
          submodules,
        })

        newOrder++
      }
    }
    return newArray
  }

  const fetchPermissionsRole = async () => {
    try {
      const { data: rolePermissionsData } = await rolePermissions({
        variables: { id_role: parseInt(_id) },
      })

      const dataResp = rolePermissionsData.getAllRolePermissions

      const dataArray = await trasformData(dataResp.rolePermissionsModule)

      setRole({
        name: dataResp.role_name,
        description: dataResp.description,
      })
      setModules(dataArray)
      setBackPage('/catalog/roles')
    } catch (error) {
      toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const fetchPermissionsUser = async () => {
    try {
      const { data: userPermissionsData } = await userPermissions({
        variables: { userID: parseInt(_id) },
      })
      const dataResp = userPermissionsData.getAllUserPermissions
      const dataArray = await trasformData(dataResp)

      setModules(dataArray)
      setBackPage('/catalog/users')
    } catch (error) {
      toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  //EFECTS
  useEffect(() => {
    if (_id) {
      if (typePermiss === 'role') {
        fetchPermissionsRole()
      } else if (typePermiss === 'user') {
        fetchPermissionsUser()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, typePermiss])

  const handleSave = async () => {
    const itemsOrder = modules.map((item, index) => ({
      id_module: item.id_module,
      order: index + 1,
    }))

    showLoading()

    try {
      await updateOrderPermissions({
        variables: {
          typePermiss,
          idTypePermiss: parseInt(_id),
          input: itemsOrder,
        },
      })

      if (typePermiss === 'role') {
        await fetchPermissionsRole()
      } else if (typePermiss === 'user') {
        await fetchPermissionsUser()
      }

      return toastSweetAlert({
        mode: 'ok',
        message: 'Se guardo el ordenamiento correctamente',
      })
    } catch (error) {
      toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <ContentHeader
        title=""
        titleContent={
          <div className="col-12 col-sm-6">
            <Link
              className="btn btn-migrates-white mb-3"
              to={`${backPage}`}
            >
              <i className="fas fa-long-arrow-alt-left" /> Atrás
            </Link>
            <h1 className="header-title">
              Ordenar modulos permitidos del{' '}
              {typePermiss === 'role' ? 'Rol' : 'Usuario'}
            </h1>
            {role && (
              <span>
                {role.name} ({role.description})
              </span>
            )}
          </div>
        }
        breadcrumb=""
        windowTitle={`Ordenar modulos permitidos`}
      />

      {modules && modules.length > 0 && (
        <Box
          title="Permisos"
          subTitle="(Solo arrastra el elemento en la pila)"
          btnRedTxt="Cancelar"
          btnRedPath={backPage}
          btnSubmitNoEnter={() => handleSave()}
          btnSubmitNoEnterTxtSave="Guardar ordenamiento"
          btnSubmitNoEnterTxtUpdate="Guardar ordenamiento"
          content={
            <ReorderItems
              items={modules}
              setItems={setModules}
              type={typePermiss}
            />
          }
        />
      )}
    </>
  )
}

export default OrderPermissions
